import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import approved from "../../images/chart-success.png";

export default function ApprovedReports({ report }) {
  return <ReportCard title="Approved Reports" text={report} src={approved} />;
}
